import { Component, OnInit, ViewEncapsulation, Inject } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-sort',
  templateUrl: './sort.component.html',
  styleUrls: ['./sort.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SortComponent implements OnInit {

  productSort: any;
  public sortings = [];
  sorts: any;
  constructor(
    private bottomSheet: MatBottomSheetRef<SortComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any
    ) { 

      this.data=data;
      this.productSort=this.data.sort;
      this.sortings=this.data.sortData;
    }

  ngOnInit() {

  }

  radioChange(sort){

    this.bottomSheet.dismiss({event:'update',sort:sort})
  }

}
